import script from "./BuildingSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuildingSelector.vue?vue&type=script&lang=ts&setup=true"

import "./BuildingSelector.vue?vue&type=style&index=0&id=42a04e7f&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a04e7f"]])

export default __exports__